import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import { uploadFile } from "@/lib/api";

export default function UploadField({ label, value, onChange, accept, testid }) {
    const inputRef = useRef(null);
    const [uploading, setUploading] = useState(false);

    const pick = () => inputRef.current?.click();

    const handle = async (e) => {
        const file = e.target.files?.[0];
        e.target.value = "";
        if (!file) return;
        setUploading(true);
        try {
            const res = await uploadFile(file);
            onChange(res.url);
            toast.success(`Uploaded ${res.original_filename}`);
        } catch (err) {
            toast.error(err.response?.data?.detail || "Upload failed. Please try again.");
        } finally {
            setUploading(false);
        }
    };

    return (
        <div>
            <span className="font-mono-brand text-[10px] uppercase tracking-[0.18em] text-ink/60">
                {label}
            </span>
            <div className="mt-1.5 flex gap-2">
                <input
                    data-testid={`${testid}-input`}
                    className="flex-1 min-w-0 bg-paper border-2 border-ink px-3.5 py-2.5 text-sm text-ink placeholder:text-ink/40 focus:outline-none focus:ring-2 focus:ring-pink transition-shadow duration-150"
                    placeholder="Paste a URL or upload →"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                />
                <button
                    type="button"
                    data-testid={`${testid}-upload-btn`}
                    onClick={pick}
                    disabled={uploading}
                    className="shrink-0 inline-flex items-center gap-1.5 bg-mustard/40 text-ink font-sub font-bold text-sm px-4 py-2.5 border-2 border-ink transition-colors duration-150 hover:bg-mustard/60 disabled:opacity-60"
                >
                    {uploading ? (
                        <Loader2 className="w-4 h-4 animate-spin" />
                    ) : (
                        <Upload className="w-4 h-4" />
                    )}
                    {uploading ? "Uploading…" : "Upload"}
                </button>
                <input
                    ref={inputRef}
                    type="file"
                    accept={accept}
                    onChange={handle}
                    className="hidden"
                    data-testid={`${testid}-file-input`}
                />
            </div>
        </div>
    );
}
